module.exports = __webpack_public_path__ + "static/media/password.687a321d.svg";